var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"block":"","elevation":"0","max-height":_vm.maxHeight,"max-width":"100%"}},[_c('v-img',{attrs:{"src":_vm.item.banner,"max-height":_vm.maxHeight,"max-width":"100%","contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }